import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { cn } from "../../../../lib/utils";
import { truncateAddress } from "../../../../lib/format";

export function WalletCell({ address, active, className }) {
  const [copied, setCopied] = useState(false);

  async function copy(e) {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* noop */
    }
  }

  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          active ? "bg-ginox-green" : "bg-white/10",
        )}
      />
      <span className="font-mono text-sm text-foreground">
        {truncateAddress(address)}
      </span>
      <button
        type="button"
        onClick={copy}
        className="text-muted-foreground/50 opacity-0 transition-opacity hover:text-foreground group-hover:opacity-100"
        aria-label="Copy wallet address"
      >
        {copied ? (
          <Check className="h-3 w-3 text-ginox-green" />
        ) : (
          <Copy className="h-3 w-3" />
        )}
      </button>
    </span>
  );
}
